import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { AuthLayout } from "../../components/AuthLayout";
import { OAuthButtons } from "./OAuthButtons";
import { useAuth } from "../../lib/auth";
import { ErrorMessage } from "../../components/ErrorMessage";
import { Field } from "../../components/Field";

// Strip the leading HTTP status the API client prefixes onto error messages.
function friendly(message) {
  return String(message || "Something went wrong.").replace(/^\d{3}\s+/, "");
}

export function Login() {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  // Already signed in — skip the form and head to the intended page.
  if (isAuthenticated) return <Navigate to={from} replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(friendly(err.message));
      setBusy(false);
    }
  }

  return (
    <AuthLayout
      title="Sign in"
      subtitle="Welcome back. Pick up where you left off."
      footer={
        <span>
          New to X·RING? <Link to="/signup">Create an account</Link>
        </span>
      }
    >
      <OAuthButtons />

      <form className="auth-form" onSubmit={onSubmit}>
        <ErrorMessage message={error} />

        <Field variant="auth" label="Email">
          <input
            type="email"
            className="input"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Field>

        <Field
          variant="auth"
          label="Password"
          labelExtra={
            <Link to="/forgot-password" className="auth-label-link">
              Forgot?
            </Link>
          }
        >
          <input
            type="password"
            className="input"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Field>

        <button type="submit" className="btn primary auth-submit" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </AuthLayout>
  );
}
